<template>
    <b-container fluid>
        <b-row align-h="center">
            <b-col cols="12" sm="8" lg="5">

                <div class="div-section-header">
                    <b-row>
                        <b-col cols="12">
                            <div>
                                <span class="txt-section-title">About Us</span>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <div class="div-section-body">
                    <b-row style="padding: 10px;">
                        <b-col cols="12">
                            <p>Owned and managed by <a href="https://vivalearningllc.com" class="contentLinks" target="_blank">Viva Learning LLC</a>, Viva Learning&trade; is an industry-wide dental continuing education platform that delivers free CE accredited content through the convenience of the Internet. Webinars are prepared and presented by today's most respected clinicians, speakers and dental educators.</p>
                            <p>Viva Learning&trade; is committed to providing free online access to high quality, clinically relevant presentations (interactive and on-demand), with the goal of helping dental professionals improve the way they practice dentistry. Viva Learning&trade; is supported by corporations, organizations and other entities that are interested in and dedicated to high quality, continuing dental education.</p>

                            <hr size="1">
                            <div>
                                <p>
                                <img src="@/art/logos/agd-pace.jpg" width="323" height="156" alt="Academy of General Dentistry - PACE"><br>
                                Viva Learning<br>
                                Nationally-approved PACE Program Provider for FAGD/MAGD credit<br>
                                Approval does not imply acceptance by any regulatory authority or AGD endorsement<br>
                                11/1/2025 – 10/31/2029 Provider #217544
                                </p>

                                <p>
                                <img src="@/art/logos/dental-board-of-california.jpg" width="304" height="166" alt="Dental Board of California"><br>
                                Viva Learning, LLC is a Registered CE Provider with the CA Dental Board<br>
                                Provider # RP5747<br>
                                Term through 6/30/2028
                                </p>
                            </div>
                        </b-col>
                    </b-row>
                </div>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>
/* eslint-disable */

export default {
    name: "AboutUs",
    data() {
        return {
            debug: false,
            error: false,
            errorMsg: 'System error - contact tech support.',
            busy: false,
            studentHash: this.$root.getToken() || null,
        }
    },
    props: {},
    computed: {},
    methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue